import { ImageEntity } from "interfaces";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Button, Icon, Image, Modal } from "semantic-ui-react";
import { api, ui } from "services";

export default function UploadImage({
  value,
  onChange,
}: {
  value: string;
  onChange: Function;
}) {
  const [showPopup, setShowPopup] = useState<boolean>(false);

  // function renderPopup() {
  //   return (
  //     <div className="relative w-36 cursor-pointer" {...getRootProps()}>
  //       <p>Upload image</p>
  //       <input {...getInputProps()} />
  //       <Image
  //         rounded
  //         alt="avatar"
  //         src={value || "/default-avatar.png"}
  //         size="small"
  //       />
  //       <i className="fas fa-edit text-primary-700 absolute bottom-0 right-0 text-xl" />
  //     </div>
  //   );
  // }
  return (
    <>
      <Modal
        open={showPopup}
        closeIcon
        onClose={() => {
          setShowPopup(false);
        }}
      >
        <Modal.Content>
          <ImageSelector
            onSelect={(url: string) => {
              onChange(url);
              setShowPopup(false);
            }}
          />
        </Modal.Content>
      </Modal>
      <div className="border-4 p-2 inline-block hover:border-blue-600 rounded-md transition-all duration-200">
        <Image
          onClick={() => {
            setShowPopup(true);
          }}
          rounded
          className="cursor-pointer inline"
          alt="avatar"
          src={value || "/default-avatar.png"}
          size="small"
        />
      </div>
    </>
  );
}
function ImageSelector({ onSelect }: { onSelect: Function }) {
  const [loading, setLoading] = useState(false);

  const [images, setImages] = useState<ImageEntity[]>([]);
  const [selected, setSelected] = useState<ImageEntity>(null);
  useEffect(() => {
    async function loadImage() {
      let rs = await api.post("/operation/api/get-image", {});
      setImages(rs.data);
    }
    loadImage();
  }, []);
  const onDrop = (acceptedFiles: any[]) => {
    if (!acceptedFiles.length) return;
    uploadAvatar(acceptedFiles[0]);
  };
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  async function uploadAvatar(image: any) {
    try {
      setLoading(true);
      let rs = await api.postFormData(`/file/upload-operation-image`, {
        image,
      });
      // onChange(rs.url);
      let tmp = _.cloneDeep(images);
      tmp.unshift(rs);
      setImages(tmp);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }
  async function deleteImage() {
    await ui.confirm("Are you sure want to delete this image?");
    await api.post("/file/delete-operation-image", { id: selected.id });
    let tmp = _.cloneDeep(images);
    tmp = tmp.filter((i) => i.id !== selected.id);
    setImages(tmp);
  }
  return (
    <div>
      <div className="flex justify-between">
        <p className="font-semibold uppercase">Select image</p>
        <div className="flex gap-2">
          <div className="relative cursor-pointer" {...getRootProps()}>
            <input {...getInputProps()} />
            <Button
              icon="upload"
              content="Upload"
              color="pink"
              loading={loading}
            />
          </div>
          <Button
            disabled={!selected}
            onClick={() => {
              onSelect(selected.url);
            }}
            icon="check"
            content="Select"
            color="blue"
            loading={loading}
          />
          <Button
            disabled={!selected}
            onClick={() => {
              deleteImage();
            }}
            icon="close"
            content="Delete"
            color="red"
            loading={loading}
          />
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mt-4 max-h-[600px] overflow-auto">
        {images.map((i: ImageEntity, index: number) => (
          <div
            className={`p-2 border-4 rounded-md ${
              selected?.id === i.id
                ? "border-blue-700"
                : "hover:border-gray-400 "
            }`}
            onClick={() => {
              if (i.id === selected?.id) {
                setSelected(null);
              } else {
                setSelected(i);
              }
            }}
          >
            <img src={i.url} className="w-48 h-32 object-cover rounded-md" />
            <div className="flex justify-between">
              <p className="text-center">
                {i.format} {i.width}x{i.height}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
